import React from "react"
import styled from "styled-components"
import Parser from "html-react-parser"

import globalVariables from "../globalVariables"
import Title from "../elements/Title"
import Button from "../elements/Button"
import Anchor from "../elements/Anchor"

const Row = styled.section`
  display: flex;
  flex-direction: column;
  @media (min-width: ${globalVariables.minTablet}) {
    flex-direction: row;
    align-items: stretch;
    align-content: stretch;
    min-height: 425px;
  }
`

const WrapperImage = styled.div`
  position: relative;
  background: url(${props => props.imageUrl});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media (min-width: ${globalVariables.minTablet}) {
    flex: 1 1 65%;
  }
  @media (min-width: ${globalVariables.minDesktop}) {
    flex: 1 1 72%;
  }
`

const Content = styled.div`
  width: 100%;
  height: 100%;
  padding: 50px 20px;
  background: rgba(81, 85, 93, 0.8);
  .title1.trait::after {
    background-color: ${props => props.theme.primary};
  }
  @media (min-width: ${globalVariables.minTablet}) {
    padding: 70px 60px;
  }
`

const Subtitle = styled.p`
  font-size: 22px;
  font-weight: bold;
  color: white;
  padding-top: 40px;
`

const Text = styled.div`
  p {
    color: white;
  }
  max-width: 840px;
`
const WrapperDate = styled.div`
  background-color: ${props => props.theme.primary};
  padding: 50px 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  .title1 {
    margin-bottom: 20px;
  }
  p {
    color: white;
    font-size: 20px;
    margin-bottom: 5px;
  }
  @media (min-width: ${globalVariables.minTablet}) {
    flex: 1 1 35%;
  }
  @media (min-width: ${globalVariables.minDesktop}) {
    flex: 1 1 28%;
  }
`

const WrapperAnchor = styled.div`
  position: absolute;
  top: -24px;
  left: 50%;
  transform: translateX(-50%);
  @media (min-width: ${globalVariables.minTablet}) {
    top: 50%;
    left: -24px;
    transform: translateY(-50%) rotate(-90deg);
  }
`

const Event = ({ banner, titre, texte, date, heure, adresse, lieu, lien }) => {
  return (
    <Row>
      <WrapperImage imageUrl={banner}>
        {/* <Img fluid={banner} /> */}
        <Content>
          <Title traitLeft="-60px" className="title1 trait" color="white">
            Prochain évènement
          </Title>
          <Subtitle>{titre}</Subtitle>
          <Text>{Parser(texte)}</Text>
        </Content>
      </WrapperImage>
      <WrapperDate id="date-evenement">
        <WrapperAnchor>
          <Anchor
            anchor="date-evenement"
            offset={globalVariables.navbarHeight}
          />
        </WrapperAnchor>
        <Title className="title1" color="white" position="center">
          {date}
        </Title>
        <p>{heure}</p>
        <p>
          <b>{lieu}</b>
        </p>
        <p>{adresse}</p>
        <Button
          as="external-link"
          to={lien}
          title="Je m'inscris"
          colors="primary"
          margin="20px 0 0 0"
        />
      </WrapperDate>
    </Row>
  )
}

export default Event
